import { __decorate } from "tslib";
import React, { Children, Component, isValidElement } from 'react';
import isNil from 'lodash/isNil';
import ConfigContext from 'choerodon-ui/lib/config-provider/ConfigContext';
import { TooltipPlacement, TooltipTheme } from 'choerodon-ui/lib/tooltip';
import Trigger from 'choerodon-ui/lib/trigger/Trigger';
import { Action } from 'choerodon-ui/lib/trigger/enum';
import getPlacements from './placements';
import autobind from '../_util/autobind';
export { TooltipPlacement, TooltipTheme };
const splitObject = (obj, keys) => {
    const picked = {};
    const ommitted = { ...obj };
    keys.forEach(key => {
        if (obj && key in obj) {
            picked[key] = obj[key];
            delete ommitted[key];
        }
    });
    return { picked, ommitted };
};
/**
 * Fix the tooltip won't hide when child element is button
 * @param element ReactElement
 */
function getDisabledCompatableChildren(element) {
    const elementType = element.type;
    const { props } = element;
    if (elementType === 'button' && props.disabled) {
        const { style, block, className } = props;
        const { picked, ommitted } = splitObject(style, [
            'position',
            'left',
            'right',
            'top',
            'bottom',
            'float',
            'display',
            'zIndex',
        ]);
        const spanStyle = {
            display: 'inline-block',
            ...picked,
            cursor: 'not-allowed',
            width: block ? '100%' : null,
        };
        const buttonStyle = {
            ...ommitted,
            pointerEvents: 'none',
        };
        const child = React.cloneElement(element, {
            style: buttonStyle,
            className: null,
        });
        return (React.createElement("span", { style: spanStyle, className: className }, child));
    }
    return element;
}
const PopupContent = (props) => {
    const { content, prefixCls, theme, translate: { x, y } } = props;
    const arrowCls = `${prefixCls}-popup-arrow`;
    const contentCls = `${prefixCls}-popup-inner`;
    const arrowStyle = x || y ? { marginLeft: -x, marginTop: -y } : undefined;
    return (React.createElement("div", null,
        React.createElement("div", { className: `${arrowCls} ${arrowCls}-${theme}`, style: arrowStyle }),
        React.createElement("div", { className: `${contentCls} ${contentCls}-${theme}` }, content)));
};
export default class Tooltip extends Component {
    constructor() {
        super(...arguments);
        this.state = {
            translate: { x: 0, y: 0 },
        };
    }
    static get contextType() {
        return ConfigContext;
    }
    get prefixCls() {
        const { suffixCls, prefixCls } = this.props;
        const { context } = this;
        return context.getProPrefixCls(suffixCls, prefixCls);
    }
    get placements() {
        const { builtinPlacements, arrowPointAtCenter, autoAdjustOverflow } = this.props;
        return (builtinPlacements ||
            getPlacements({
                arrowPointAtCenter,
                verticalArrowShift: 8,
                autoAdjustOverflow,
            }));
    }
    getContent(...props) {
        const { title, overlay } = this.props;
        if (typeof overlay === 'function') {
            return overlay(...props);
        }
        if (overlay) {
            return overlay;
        }
        if (typeof title === 'function') {
            return title(...props);
        }
        return title;
    }
    handlePopupAlign(_source, _align, _target, translate) {
        const { translate: { x, y } } = this.state;
        if (x !== translate.x || y !== translate.y) {
            this.setState({
                translate,
            });
        }
    }
    renderPopupContent(...props) {
        const { translate } = this.state;
        const { getTooltipTheme } = this.context;
        const { theme = getTooltipTheme() } = this.props;
        const content = this.getContent(...props);
        if (content) {
            return (React.createElement(PopupContent, { content: content, theme: theme, prefixCls: this.prefixCls, translate: translate }));
        }
    }
    render() {
        const { prefixCls, props: { children, placement, onHiddenChange, onHiddenBeforeChange, trigger, defaultHidden, hidden, getRootDomNode, ...restProps }, } = this;
        // 修复特殊情况为0，以及 undefined 出现的报错情况
        const child = Children.count(children) ? Children.map(children, node => (!isNil(node) && (isValidElement(node) ? getDisabledCompatableChildren(node) : React.createElement("span", { key: `text-${node}` }, node)))) : null;
        const hasHiddenProp = 'hidden' in this.props;
        if (hasHiddenProp) {
            restProps.popupHidden = hidden;
        }
        delete restProps.theme;
        return !isNil(child) || (getRootDomNode && hasHiddenProp) ? (React.createElement(Trigger, Object.assign({ prefixCls: prefixCls, action: trigger, builtinPlacements: this.placements, popupPlacement: placement, popupContent: this.renderPopupContent, onPopupHiddenBeforeChange: onHiddenBeforeChange, onPopupHiddenChange: onHiddenChange, onPopupAlign: this.handlePopupAlign, defaultPopupHidden: defaultHidden, getRootDomNode: getRootDomNode }, restProps), child)) : child;
    }
}
Tooltip.displayName = 'Tooltip';
Tooltip.defaultProps = {
    suffixCls: 'tooltip',
    placement: 'top',
    transitionName: 'zoom-big-fast',
    mouseEnterDelay: 100,
    mouseLeaveDelay: 100,
    arrowPointAtCenter: false,
    autoAdjustOverflow: true,
    defaultHidden: true,
    trigger: [Action.hover],
};
__decorate([
    autobind
], Tooltip.prototype, "handlePopupAlign", null);
__decorate([
    autobind
], Tooltip.prototype, "renderPopupContent", null);
